/* unplugin-vue-components disabled */import { render } from "./ItemsSorting.vue?vue&type=template&id=6bb0c330&scoped=true&ts=true"
import script from "./ItemsSorting.vue?vue&type=script&lang=ts"
export * from "./ItemsSorting.vue?vue&type=script&lang=ts"

import "./ItemsSorting.vue?vue&type=style&index=0&id=6bb0c330&lang=scss&scoped=true"
import "./ItemsSorting.vue?vue&type=style&index=1&id=6bb0c330&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb0c330"]])

export default __exports__